import React from "react";
import _ from "lodash";
import { renderLayout } from "schema/ThemeSet.react";
import OptionButton from "slides/components/OptionButton.react";
export default class ScoredMCQ extends React.Component {
    handleClick = (index) => {
        this.props.trackInteraction(index);
    };

    render() {
        let isPortrait =
            this.props.mobileView || window.innerHeight > window.innerWidth;
        let LayoutRender = renderLayout(isPortrait, this.props.layout);

        let mappedOptions = _.map(
            this.props.data.taggedselect,
            (option, index) => {
                return (
                    <OptionButton
                        {...this.props}
                        fluid
                        index={index}
                        key={"button-" + index}
                        name={"" + option.option}
                        handleClick={this.handleClick}
                    />
                );
            }
        );
        return (
            <div className="full-height">
                <LayoutRender
                    {...this.props}
                    title={"Choose an option:"}
                    mainContent={mappedOptions}
                />
            </div>
        );
    }
}
